import React, { useState, useRef } from 'react';
import {
    createStyles,
    makeStyles, Step, StepConnector, StepConnectorProps, StepIconProps, StepLabel, Stepper,
    Theme, withStyles,
} from '@material-ui/core';
import clsx from 'clsx';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons';

import { Stage } from '../../../data/Repair';
import { useWindowResizeEffect } from '../../../units/useWindowResizeEffect';

type StageListProps = {
    stageList: Stage[],
    onItemClick?: (item: Stage) => void,
    onItemDeleteClick?: (item: Stage) => void,
    listRef?: React.RefObject<HTMLDivElement>,
};

StageList.defaultProps = {
    onItemClick: () => {},
    onItemDeleteClick: () => {},
    listRef: null,
};

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    container: {
        height: '100%',
    },
    stepLabel: {
        '& .MuiStepLabel-label': {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            color: theme.palette.text.primary,
            fontWeight: 500,
        },
    },
    stepLabelDate: {
        color: theme.palette.text.secondary,
    },
}));

const useStageStepIconStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 24,
        width: 24,
        color: '#eaeaf0',
        borderRadius: '50%',
        fontSize: 12,
        backgroundColor: theme.palette.primary.main,
        lineHeight: 0,
    },
    active: {
        backgroundColor: theme.palette.primary.main,
    },
    completed: {
        backgroundColor: theme.palette.success.main,
    },
    error: {
        backgroundColor: theme.palette.warning.main,
    },
}));

function StageStepIcon(props: StepIconProps) {
    const classes = useStageStepIconStyles();
    const {
        active,
        completed,
        error,
        icon,
    } = props;

    function renderIcon() {
        if (completed) {
            return (<Icon icon={faCheck} />);
        }

        if (error) {
            return (<Icon icon={faExclamation} />);
        }

        return icon;
    }

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
                [classes.error]: error,
            })}
        >
            {renderIcon()}
        </div>
    );
}

function StageList(props: StageListProps): React.ReactElement {
    const {
        stageList,
    } = props;
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Stepper orientation="vertical" connector={<StepConnector />}>
                {stageList.sort((a, b) => Number(a.id) - Number(b.id)).map((item) => (
                    <Step completed={item.completed_is === 'Y'}>
                        <StepLabel
                            className={classes.stepLabel}
                            error={item.completed_is === 'P'}
                            StepIconComponent={StageStepIcon}
                        >
                            <span>{item.front_stage}</span>
                            <span className={classes.stepLabelDate}>{item.completed_is === 'Y' ? item.completed_date : `預計 ${item.schedule_date}`}</span>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </div>
    );
}

export { StageList };
